module.exports = __webpack_public_path__ + "static/img/icon_start.dfba46a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_start.png
// module id = 642
// module chunks = 2